import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BankDetailsUpdate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '',
    bank: '',
    account: '',
    ifsc: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBankDetails = async () => {
      const userId = localStorage.getItem("userid");
      if (!userId) {
        navigate('/login');
        return;
      }

      try {
        const response = await fetch(`https://fx4money.com/Rest/user_details_api/${userId}`);
        const data = await response.json();
        setForm({
          name: data.acc_holder || '',
          bank: data.bank_name || '',
          account: data.acc_no || '',
          ifsc: data.ifsc || ''
        });
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchBankDetails();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.name || !form.bank || !form.account || !form.ifsc) {
      alert('Please fill all fields');
      return;
    }

    setLoading(true);
    const userId = localStorage.getItem("userid");

    // Using FormData
    const formData = new FormData();
    formData.append('id', userId);
    formData.append('acc_holder', form.name);
    formData.append('bank_name', form.bank);
    formData.append('acc_no', form.account);
    formData.append('ifsc', form.ifsc);

    try {
      const response = await fetch('https://fx4money.com/Rest/web_bank_update_api2', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      alert(result.msg || 'Bank details updated');
      
      if (response.ok) {
        navigate(-1);
      }
    } catch (error) {
      alert('Failed to update bank details');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid bg-light min-vh-100">
      {/* Header */}
      <div className="bg-primary text-white p-3">
        <div className="container">
          <div className="d-flex align-items-center">
            <button 
              className="btn btn-link text-white p-0 me-3"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left fs-5"></i>
            </button>
            <h5 className="mb-0">Bank Details</h5>
          </div>
          <p className="mb-0 mt-2 opacity-75 small">
            Secure banking information for withdrawals
          </p>
        </div>
      </div>

      {/* Form */}
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <form onSubmit={handleSubmit}>
              {/* Account Holder */}
              <div className="mb-3">
                <label className="form-label fw-bold">Account Holder Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Full name as per bank"
                  required
                />
              </div>

              {/* Bank Name */}
              <div className="mb-3">
                <label className="form-label fw-bold">Bank Name</label>
                <input
                  type="text"
                  name="bank"
                  className="form-control"
                  value={form.bank}
                  onChange={handleChange}
                  placeholder="Bank name"
                  required
                />
              </div>

              {/* Account Number */}
              <div className="mb-3">
                <label className="form-label fw-bold">Account Number</label>
                <input
                  type="text"
                  name="account"
                  className="form-control"
                  value={form.account}
                  onChange={handleChange}
                  placeholder="Account number"
                  required
                />
              </div>

              {/* IFSC Code */}
              <div className="mb-4">
                <label className="form-label fw-bold">IFSC Code</label>
                <input
                  type="text"
                  name="ifsc"
                  className="form-control"
                  value={form.ifsc}
                  onChange={handleChange}
                  placeholder="Bank IFSC code"
                  required
                />
              </div>

              {/* Security Info */}
              <div className="alert alert-primary mb-4">
                <div className="d-flex">
                  <i className="bi bi-shield-check me-2"></i>
                  <div>
                    <strong>Secure Storage</strong>
                    <p className="mb-0 small">Your banking details are encrypted and never shared with third parties.</p>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <button type="submit" className="btn btn-primary w-100 py-3 fw-bold" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Saving Details...
                  </>
                ) : (
                  'SAVE BANK DETAILS'
                )}
              </button>

              {/* Quick Tips */}
              <div className="card mt-4 border-0 shadow-sm">
                <div className="card-body">
                  <h6 className="card-title">
                    <i className="bi bi-lightbulb text-warning me-2"></i>
                    Tips for Accurate Details
                  </h6>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-1">
                      <i className="bi bi-check text-primary me-2"></i>
                      Use name exactly as in bank passbook
                    </li>
                    <li className="mb-1">
                      <i className="bi bi-check text-primary me-2"></i>
                      Find IFSC code on cheque leaf or net banking
                    </li>
                    <li>
                      <i className="bi bi-check text-primary me-2"></i>
                      Verify account number twice before saving
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankDetailsUpdate;